export var SIZE_MAPPER = {
  0: 0,
  px: 1,
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  2.5: 10,
  3: 12,
  3.5: 14,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  11: 44,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  28: 112,
  32: 128,
  36: 144,
  40: 160
};
export default (function () {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 0) {
      console.warn('Please provide some values for the spacer method !');
      return SIZE_MAPPER[2.5];
    }

    var keys = Object.keys(SIZE_MAPPER).map(Number).sort(function (a, b) {
      return a - b;
    }).join(', ');

    if (args.length === 1) {
      var size = SIZE_MAPPER[args[0]];

      if (!size && size !== 0) {
        console.warn("Please provide correct value for the spacer method: ".concat(keys));
        return SIZE_MAPPER[2.5];
      }

      return size;
    }

    var isValidValues = args.every(function (value) {
      return SIZE_MAPPER[value] === 0 || SIZE_MAPPER[value];
    });

    if (isValidValues) {
      return args.map(function (spacing) {
        return "".concat(SIZE_MAPPER[spacing], "px");
      }).join(' ');
    }

    console.warn("Please provide correct value: ".concat(keys.join(', '), ", your current values is: ").concat(args.join(', ')));
  };
});